export const KeyboardEventConstant = {
  BACKSPACE: {
    KEY: 'Backspace',
    WHICH: 8,
  },
  DELETE: {
    KEY: 'Delete',
    WHICH: 46,
  },
  ENTER: {
    KEY: 'Enter',
    WHICH: 13,
  },
};
